import { render, staticRenderFns } from "./eventData.vue?vue&type=template&id=4e4f861d"
import script from "./eventData.vue?vue&type=script&lang=js"
export * from "./eventData.vue?vue&type=script&lang=js"
import style0 from "./eventData.vue?vue&type=style&index=0&id=4e4f861d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports